<script setup>
// Recursive block renderer for the content-page template. Maps each block's
// `type` to a component and renders the list in order. Used at page level and,
// recursively, inside ContentSection's right column.
//
// ContentSection imports ContentBlocks back, forming an import cycle. Static
// imports keep rendering synchronous (needed so nested section content is in
// the SSG-prerendered HTML, not hydrated in later). The registry resolves via
// thunks so the (possibly still-undefined during circular module eval)
// ContentSection binding is read at render time, when it's fully initialised.
import RichTextBlock from './RichTextBlock.vue'
import AccordionBlock from './AccordionBlock.vue'
import QuoteBlock from './QuoteBlock.vue'
import FigureBlock from './FigureBlock.vue'
import ContentSection from './ContentSection.vue'
import LinkCardsBlock from './LinkCardsBlock.vue'
import MediaCardsBlock from './MediaCardsBlock.vue'
import DownloadsBlock from './DownloadsBlock.vue'
import ResourceMetaCard from './ResourceMetaCard.vue'
import RelatedStories from './RelatedStories.vue'
import ProgramCardsBlock from './ProgramCardsBlock.vue'
import ProfileCardsBlock from './ProfileCardsBlock.vue'
import SectionLinkCardsBlock from './SectionLinkCardsBlock.vue'
import NewsletterBlock from './NewsletterBlock.vue'
import IconListBlock from './IconListBlock.vue'

const registry = {
  section:       () => ContentSection,
  richText:      () => RichTextBlock,
  accordion:     () => AccordionBlock,
  quote:         () => QuoteBlock,
  figure:        () => FigureBlock,
  linkCards:     () => LinkCardsBlock,
  sectionCards:  () => SectionLinkCardsBlock,
  mediaCards:    () => MediaCardsBlock,
  downloads:     () => DownloadsBlock,
  resourceCard:  () => ResourceMetaCard,
  relatedStories: () => RelatedStories,
  programCards:  () => ProgramCardsBlock,
  profileCards:  () => ProfileCardsBlock,
  newsletter:    () => NewsletterBlock,
  iconList:      () => IconListBlock,
}

defineProps({
  blocks: { type: Array, default: () => [] },
})

const resolve = (type) => (registry[type] ? registry[type]() : null)
</script>

<template>
  <template v-for="(block, i) in blocks" :key="i">
    <component :is="resolve(block.type)" v-if="resolve(block.type)" :block="block" />
  </template>
</template>
